<dxc-date-input *ngIf="dateformats == 'dd/mm/yyyy'"
    label="{{label | translate}}"
    [value]="model"
    (onChange)="onChangeDate($event)"
    (onBlur)="onBlur($event)"
    format="dd/MM/yyyy"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [error]="errorMessage"
    size="fillParent"
    [class.required]="required"
  >
  </dxc-date-input>
  <dxc-date-input *ngIf="dateformats == 'mm/dd/yyyy'"
    label="{{label | translate}}"
    [value]="model"
    (onChange)="onChangeDate($event)"
    (onBlur)="onBlur($event)"
    format="MM/dd/yyyy"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [error]="errorMessage"
    size="fillParent"
    [class.required]="required"
  >
  </dxc-date-input>